import { json, useSearchParams } from "react-router-dom";
import ResendActivationForm from "../../components/forms/ResendActivationForm";
import SmallAlert from "../../components/ui/alerts/SmallAlert";
import Logo from "../../utils/components/Logo";

function ActivationConfirmationPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  return (
    <main className="mainOneOne">
      <div className="content colCenter">
        <Logo className="activation-logo" />

        {token === "" ? (
          <div className="activation-alert">
            <SmallAlert
              alert="True"
              type="error"
              message={"Activation email failed."}
            />
          </div>
        ) : (
          <>
            <div className="infoQuestions inProgress">
              <div>
                <span className="mFont activation-mail-icon">
                  mark_email_unread
                </span>
                <h2>Check your email</h2>
                <p>
                  We’ve sent an activation email. Please check your inbox and
                  click the link to activate your account.
                </p>
              </div>
            </div>

            <div className="blueRect centered activation-tips">
              <p>
                • If you don’t see it, check your spam or promotions folder.
              </p>
              <p>• It may take a few seconds to arrive.</p>
            </div>
          </>
        )}

        <h5 className="text-center">Didn’t receive the email?</h5>
        <ResendActivationForm token={token} />
      </div>
    </main>
  );
}

export default ActivationConfirmationPage;

export async function action({ request }) {
  const formData = await request.formData();
  const token = formData.get("token");

  const endpointPath = "account/resend-activation";
  const apiBaseUrl = process.env.REACT_APP_API_DOMAIN;
  const urlPath = apiBaseUrl.concat("/", endpointPath);

  const response = await fetch(urlPath, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ token }),
  });

  const data = await response.json();

  if (!response.ok) {
    return json(
      { error: data.message || "Could not resend activation email." },
      { status: response.status }
    );
  }

  return json({
    success: data.message || "Activation email sent successfully.",
  });
}
